import React from "react";

import { generatePagination } from "@skv/util";
import { useLocation } from "react-router-dom";

import classNames from "classnames";
import qs from "qs";

interface ResultListPaginationProps {
  currentPage: number;
  totalPages: number;
  pagesToShow?: number;
}

export const ResultListPagination: React.FC<ResultListPaginationProps> = (
  props
) => {
  const { currentPage, totalPages, pagesToShow = 5 } = props;

  const location = useLocation();

  const pagesToDisplay = generatePagination(
    currentPage,
    totalPages,
    pagesToShow
  );

  const activeIdx = pagesToDisplay.indexOf(currentPage);
  const spread = Math.floor(pagesToShow / 2);

  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const paginationListItems = pagesToDisplay.map((page, idx) => {
    const isActive = activeIdx === idx;

    const isHiddenMobile = (() => {
      if (activeIdx < spread) {
        return idx > pagesToShow - 1 - spread;
      }

      if (activeIdx > spread) {
        return idx < pagesToShow - (spread + 1);
      }

      return idx === 0 || idx === pagesToShow - 1;
    })();

    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    const pageQuery = {
      ...query,
      page,
    };

    const pageQueryString = qs.stringify(pageQuery, {
      arrayFormat: "repeat",
    });

    return (
      <li
        key={idx}
        className={classNames(
          "page-item",
          isActive && "active",
          isHiddenMobile && "d-none d-sm-inline-block"
        )}
      >
        {isActive ? (
          <span className="page-link">{page}</span>
        ) : (
          <a
            className="page-link"
            href={`${location.pathname}?${pageQueryString}`}
          >
            {page}
          </a>
        )}
      </li>
    );
  });

  return (
    <nav aria-label="Results navigation">
      <ul className="pagination flex-wrap justify-content-center">
        {currentPage !== 1 ? (
          <li className="page-item">
            <a
              className="page-link bg-white"
              href={`${location.pathname}?${qs.stringify(
                { ...query, page: currentPage - 1 },
                { arrayFormat: "repeat" }
              )}`}
            >
              Prev
              <span className="d-none visibility-hidden d-sm-inline visibility-sm-visible">
                ious
              </span>
            </a>
          </li>
        ) : null}

        {paginationListItems}

        {currentPage !== totalPages ? (
          <li className="page-item">
            <a
              className="page-link bg-white"
              href={`${location.pathname}?${qs.stringify(
                { ...query, page: currentPage + 1 },
                { arrayFormat: "repeat" }
              )}`}
            >
              Next
            </a>
          </li>
        ) : null}
      </ul>
    </nav>
  );
};
